/** @format */

import { Location } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { RESPONSE } from '@shared/data-access/constants';

@Component({
	selector: 'clp-no-content',
	templateUrl: './no-content.component.html',
	styleUrl: './no-content.component.scss',
	standalone: false
})
export class NoContentComponent implements OnInit {
	constructor(
		@Optional() @Inject(RESPONSE) private response: any,
		@Optional() private _location: Location
	) {}
	ngOnInit() {
		this.response.statusCode = 404;
	}

	responseCode(Response: any) {
		this.response = Response;
	}

	goBack() {
		this._location.back();
	}
}
